<div class="properties-list-container">
  @for (item of items; track item) {
    <div>
      <div class="dx-field">
        <div class="dx-field-label-properties">{{ item.label }}</div>
        @if (item.isEditable) {
          <div class="dx-field-value">
            <dx-text-box
              class="dx-text-box"
              [value]="item.value"
              (onValueChanged)="onValueChanged($event.value, item.label)"
            >
            </dx-text-box>
          </div>
        } @else {
          <div class="dx-field-value">{{ item.value }}</div>
        }
      </div>
    </div>
  }
</div>
